import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'Validation';
import ModalInput from 'Modals/components/ModalForm/ModalInput';
import ModalSyncedInput from 'Modals/components/ModalForm/ModalSyncedInput';
import NewAccountTermsOfService from 'NewAccountTermsOfService';


class ModalForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    this.form.validateAll();
    this.props.onSubmit(event);
  }

  render() {
    return (
      <Form
        className="form-horizontal"
        onSubmit={this.handleSubmit}
        method="POST"
        ref={(c) => { this.form = c; }}
      >
        {this.props.inputs.map(inputField => (inputField))}

        <div className="control-group">
          <div className="register-with-tos send-for-signature-with-tos">
            <NewAccountTermsOfService />
          </div>
          <button
            type="submit"
            className="btn btn-success btn-large submit-btn"
          >
            {this.props.submitLabel}
          </button>
        </div>
      </Form>
    );
  }
}

ModalForm.propTypes = {
  inputs: PropTypes.arrayOf((propValue, key, componentName, location, propFullName) => {
    if (propValue[key].type !== ModalInput && propValue[key].type !== ModalSyncedInput) {
      return new Error(
        `Invalid prop '${propFullName}' supplied to '${componentName}'. Validation failed.`,
      );
    }
    return undefined;
  }).isRequired,


  onSubmit: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
};

export default ModalForm;



// WEBPACK FOOTER //
// ./src-react/Modals/components/ModalForm/index.jsx